import React from 'react'
import { Typography, useDimensions } from '@telavita-core/react-design-kit'

import { NotificationsCardWrapper, NotificationsDisclaimer } from '../components'

import * as S from './styles'

export const PatientSettings: React.FC = () => {
  const { isMobile } = useDimensions()

  return (
    <S.Container>
      <S.Header>
        <Typography
          variant={isMobile ? 'header4' : 'header2'}
          center={isMobile}
          inlineStyles={{
            width: '100%',
            color: '#2D2D2D'
          }}
        >
          Configurações
        </Typography>
      </S.Header>

      <S.CardsContainer>
        <NotificationsCardWrapper />
        <NotificationsDisclaimer />
      </S.CardsContainer>
    </S.Container>
  )
}